import { NgClass } from '@angular/common';
import { Component } from '@angular/core';
import { ChatService } from '../chat.service';
import { CurrencyComponent } from '@shared/currency/currency.component';
import { IconComponent } from '@shared/icon/icon.component';
import { UIService } from '@shared/ui.service';

@Component({
  selector: 'app-chat-floating-section',
  templateUrl: './chat-floating-section.component.html',
  styleUrl: './chat-floating-section.component.scss',
  imports: [IconComponent, NgClass, CurrencyComponent],
})
export class ChatFloatingSectionComponent {
  constructor(public uiService: UIService, public chatService: ChatService) {}

  canJoin() {
    return this.chatService.rain.state === 2 && !this.chatService.rain.joined;
  }
}
